import script from "./LoaderPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./LoaderPopup.vue?vue&type=script&setup=true&lang=js"

import "./LoaderPopup.vue?vue&type=style&index=0&id=9018eabe&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9018eabe"]])

export default __exports__